export default [
    {path: '/platforms/:id/edit', screen: 'platform/EditPlatform', secured: true, role: ['admin']},
    {path: '/platforms/:id', screen: 'platform/DisplayPlatform', secured: true, role: ['admin']},
    {path: '/platforms', screen: 'platform/ListPlatforms', secured: true, role: ['admin']},
    {path: '/platform/new', screen: 'platform/CreatePlatform', secured: true, role: ['admin']},
]